import { useEffect } from 'react';
import {
  disabilityDefinition,
  yesNoTrueFalseOptions,
} from 'data/datas/genericData';
import Form, { FormItem } from 'components/Base/Form';
import { Text } from 'components/Base/Typography';
import { RadioGroup } from 'components/Base/Radio';
import { hasESADocumentationFormFields } from './HasESADocumentationFrom.data';
import { THasESADocumentationFromProps } from './HasESADocumentationFrom.types';
import { SRadio } from './HasESADocumentationFrom.styles';
import { Row } from 'components/Base/Grid';
import { Colors } from 'core/CssVariables';

const HasESADocumentationFrom = ({
  conversion,
  form,
}: THasESADocumentationFromProps) => {
  const { setFieldsValue } = form;
  const { requiredBecauseOfDisability } = hasESADocumentationFormFields;

  useEffect(() => {
    if (!conversion) {
      return;
    }
    setFieldsValue({
      requiredBecauseOfDisability: true,
    });
  }, [conversion]);

  return (
    <Form
      form={form}
      name="esa-documentation-form"
      autoComplete="off"
      requiredMark={false}
      id="esa-documentation-form"
      scrollToFirstError
    >
      <Row>
        <Text fontLevel={4} className="mb-2">
          Is the animal required because of a disability?
        </Text>
      </Row>
      <Row>
        <Text fontLevel={5} color={Colors.DarkGrey} className="mb-2">
          {disabilityDefinition}
        </Text>
      </Row>

      <FormItem
        {...requiredBecauseOfDisability}
        rules={[
          {
            type: 'boolean',
            required: true,
            message: 'This field is required!',
          },
        ]}
        className="mb-4 mb-0"
      >
        <RadioGroup>
          {yesNoTrueFalseOptions.map(({ value, label }) => (
            <SRadio value={value} label={label} key={label} />
          ))}
        </RadioGroup>
      </FormItem>
    </Form>
  );
};

export default HasESADocumentationFrom;
